import React, { useState } from 'react';
import FormFields from '@pages/Forms/FormFields';
import '../../GeoNonGeo.css';
interface formDataType {
  [key: string]: any;
}

type propsType = {
  formData: {
    [key: string]: any;
  };
  formState:any;
  handleFormChange:(value: any, key: string, id: any, option: any, code: any)=>void;

};

const ZoneForm = ({ formData,formState,handleFormChange }: propsType) => {


  return (
    <div className="zone_details_form_page">
      <form className="form_container_zone_details">
        <FormFields
          formData={formData}
          formState={formState}
          handleFormChange={handleFormChange}
          savedItems={[]}
        />
      </form>
    </div>
  );
};
export default ZoneForm;
